import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { getBaseUrl } from "../utils";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Bar } from 'react-chartjs-2';
import 'chart.js/auto';
import { UserContext } from './UserContext';

const Exams__test = () => {
    const { subscription } = useContext(UserContext);

    const location = useLocation();

    // end chat grapgh coding 
    const baseUrl = getBaseUrl();
    const navigate = useNavigate();
    const [latestTests, setLatestTests] = useState([]);
    const [givenTests, setGivenTests] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedTest, setSelectedTest] = useState(null);
    const [activeTab, setActiveTab] = useState(
        location.state?.activeTab || 'Latest Test'
    );
    const tabs = ['Latest Test', 'Given Tests'];

    const checkTestAccess = () => {
        if (!subscription?.features?.test_enabled) {
            return { allowed: false, message: "Your plan does not allow tests." };
        }

        const allowedLimit = subscription.features.test || 0;

        // Count how many tests already attempted
        const usedTests = givenTests.length;

        if (usedTests >= allowedLimit) {
            return {
                allowed: false,
                message: `You have reached your limit of ${allowedLimit} tests. Upgrade your plan.`
            };
        }

        return { allowed: true };
    };

    useEffect(() => {
        if (location.state?.activeTab) {
            setActiveTab(location.state.activeTab);
        }
    }, [location.state]);

    useEffect(() => {
        const fetchTestData = async (isSubmitted) => {
            const token = localStorage.getItem("userToken");
            const apiUrl = `${baseUrl}user_api/testList?isSubmitted=${isSubmitted}`;

            try {
                const response = await axios.get(apiUrl, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                if (response.data && response.data.results) {
                    if (isSubmitted) {
                        setGivenTests(response.data.results);
                    } else {
                        setLatestTests(response.data.results);
                    }
                }
            } catch (error) {
                console.error("Error fetching test data:", error);
            }
        };

        fetchTestData(false);
        fetchTestData(true);
    }, []);

    const handleAttemptClick = (test) => {
        const access = checkTestAccess();

        if (!access.allowed) {
            // alert(access.message);
            navigate("/dashboard/subscription");
            return;
        }

        if (test.price > 0) {
            setSelectedTest(test);
            if (test.isPaymentDone) {
                navigate(`/QuizForm?testId=${test._id}`);
            } else {
                setShowModal(true);
            }
        } else {
            navigate(`/QuizForm?testId=${test._id}`);
        }
    };

    const handleAttemptClick_submit = (test) => {
        navigate(`/QuizForm?testId=${test._id}`);
    };

    const handleModalClose = () => {
        setDiscount(0);
        setcoupanId(null);
        setCouponCode('');
        setCouponError('');
        setSuccessMessage('');

        setShowModal(false);
    };

    const handleCheckResultClick = async (test) => {
        try {
            const token = localStorage.getItem("userToken");
            const response = await axios.get(`${baseUrl}user_api/testResult?test_submit_Id=${test.submissionDetails._id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            setTestResult(response.data.results[0]);
            setShowResultModal(true);
        } catch (error) {
            console.error("Error fetching test result:", error);
        }
    };
    const [testResult, setTestResult] = useState(null);

    const [showResultModal, setShowResultModal] = useState(false);

    const handleResultModalClose = () => {
        setShowResultModal(false);
    };

    const subjects = testResult ? testResult.subjectsArray.map(subject => subject.name) : []; // Extract subject names for labels
    const scores = testResult ? testResult.subjectsArray.map(subject => subject.isWritingCount) : []; // Extract isWritingCount for scores

    const data = {
        datasets: [{
            label: 'Subject',
            data: scores, // Writing counts as data points
            backgroundColor: 'rgba(255, 193, 7, 0.8)',
            borderColor: 'rgba(255, 193, 7, 1)',
            borderWidth: 1,
        }],
        labels: subjects,
    };
    const renderTestList = (tests, isLatest) => {
        const allowedLimit = subscription?.features?.test || 0;
        const usedTests = givenTests.length;

        return (
            <div className="row">
                <div className="col-12 p-0 m-0">
                    {/* Horizontal Scroll Wrapper */}
                    <div className="overflow-x-auto">
                        {/* Inner Scrollable Table */}
                        <div className="min-w-[600px]">
                            {/* Header */}
                            <div
                                className="Paragraph__etxt font-[700] flex justify-between bg-[#F0F0F0] p-3 rounded-tr-xl rounded-tl-xl"
                                style={{ fontSize: '17px' }}
                            >
                                <div className="w-[80px] hidden md:block">S.No</div>
                                <div className="w-[100px]">Image</div>
                                <div className="w-[150px] flex items-center justify-center">Test Name</div>
                                <div className="w-[100px] flex items-center justify-center">Type</div>
                                <div className="w-[150px] flex items-center justify-center">Question Time</div>
                                <div className="w-[150px] flex items-center justify-center">Action</div>
                            </div>

                            {/* Rows */}
                            {tests.map((test, index) => {

                                const allowedLimit = subscription?.features?.test || 0;

        // Count how many tests already attempted
        const usedTests = givenTests.length;

        console.log("usedTests--------------->",usedTests);
        console.log("allowedLimit--------------->",allowedLimit);
        if(allowedLimit == usedTests){
          var canAttempt = false  
        }else{
            var canAttempt = true 
        }

                               // const canAttempt = isLatest && (usedTests + index < allowedLimit);//check

                                return (   // ✅ THIS IS MISSING
                                    <div
                                        key={test._id}
                                        className="Paragraph__etxt font-[600] flex justify-between p-3 border-b border-gray-200 items-center"
                                        style={{ fontSize: '14px' }}
                                    >
                                        <div className="w-[80px] hidden md:block">{index + 1}</div>
                                        <div className="w-[100px]">
                                            <img
                                                src={test.image || '/assates/Test__images.svg'}
                                                alt={test.name}
                                                className="md:w-[60px] w-[80px] h-auto"
                                            />
                                        </div>
                                        <div className="w-[150px] flex items-center justify-center">{test.name}</div>
                                        <div className="w-[100px] flex items-center justify-center">MCQ</div>
                                        <div className="w-[150px] flex items-center justify-center">{test.duration} minutes</div>
                                        <div className="w-[150px] flex items-center justify-center">
                                            {isLatest ? (
                                                <button
                                                    onClick={() => handleAttemptClick(test)}
                                                    // disabled={!canAttempt}
                                                    className={`px-3 py-1 text-white rounded-lg 
                            ${!canAttempt
                                                            ? 'bg-black cursor-not-allowed'
                                                            : 'bg-black hover:bg-gray-800'}
                            `}
                                                >
                                                    {canAttempt ? 'Attempt' : 'Upgrade Plan'}
                                                </button>
                                            ) : (
                                                <button
                                                    onClick={() => handleCheckResultClick(test)}
                                                    className="px-3 py-1 bg-black text-white rounded-lg"
                                                >
                                                    Check Result
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>

            </div>
        )
    };


    const updatedTestResult = testResult
        ? {
            ...testResult,
            needCounselling: (testResult.resultMark / testResult.fullMark) * 100 <= 50
        }
        : null;

    const token = localStorage.getItem("userToken");


    const handleRazorpayPayment = async (selectedTest) => {
        const test = selectedTest;

        try {
            const response = await axios.post(`${baseUrl}user_api/orders_create`, {
                amount: test.price - discount,
                discountamount: discount || 0,
                currency: "INR",
                receipt: "test receipt",
                notes: "test Note",
                coupanId: coupanId || null,
                testId: test._id,
                bookingId: null,
                type: "TEST"
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            const order = response.data.results; // Access the order object inside "results"

            const options = {
                key: response.data.RAZORPAYKEYID, // 🔁 Replace with your actual Razorpay Key ID
                amount: order.amount, // in paise
                currency: order.currency,
                name: "Mr-Guru",
                description: `Payment for ${test.name}`,
                order_id: order.id, // Razorpay order ID
                handler: async function (paymentResponse) {
                    console.log("Payment successful:", paymentResponse);

                    // Optionally call backend to confirm payment or update DB
                    navigate(`/QuizForm?testId=${test._id}`);
                },
                prefill: {
                    name: response.data.name,
                    email: response.data.email,
                    contact: response.data.number,
                },
                notes: order.notes,
                theme: {
                    color: "black",
                },
            };

            const rzp = new window.Razorpay(options);
            rzp.open();

        } catch (error) {
            console.error("Error creating Razorpay order:", error);
        }
    };

    const [couponCode, setCouponCode] = useState('');
    const [discount, setDiscount] = useState(0);
    const [coupanId, setcoupanId] = useState(null);

    const [couponError, setCouponError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const applyCoupon = async () => {
        setCouponError('');
        setSuccessMessage('');
        if (!couponCode) {
            setCouponError('Please enter a coupon code.');
            return;
        }
        try {
            const response = await axios.get(
                `${baseUrl}user_api/coupon?code=${couponCode}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            console.log("response-------------->", response);
            if (response.data.status && response.data.results.length > 0) {
                const coupon = response.data.results[0];
                const { discountType, discountValue, maxDiscount, minOrderValue, _id } = coupon;

                // Assuming selectedTest.amount exists (replace accordingly)
                const originalPrice = selectedTest?.price || 0;

                if (originalPrice < minOrderValue) {
                    setCouponError(`Minimum order value should be ₹${minOrderValue}`);
                    return;
                }

                let calculatedDiscount = 0;
                if (discountType === 'Percentage') {
                    calculatedDiscount = Math.min((originalPrice * discountValue) / 100, maxDiscount);
                } else {
                    calculatedDiscount = discountValue;
                }

                setDiscount(calculatedDiscount);
                setcoupanId(_id);

                setSuccessMessage(`Coupon applied! You saved ₹${calculatedDiscount}`);
            } else {
                setCouponError('Invalid or expired coupon code.');
            }
        } catch (err) {
            setCouponError('Failed to apply coupon. Please try again.');
        }
    };


    return (
        <section>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 mb-3">
                        <div className="tab-navigation flex gap-[50px] Paragraph__etxt">
                            {tabs.map((tab) => (
                                <div key={tab} className={`tab ${activeTab === tab ? 'active' : 'inactive'}`} onClick={() => setActiveTab(tab)}>
                                    {tab}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                {activeTab === 'Latest Test' ? renderTestList(latestTests, true) : renderTestList(givenTests, false)}
            </div>
            {/* <button className="btn-next" onClick={() => handleAttemptClick_submit(selectedTest)}>
                    Continue for payment
                </button> */}
            {showModal && (
                // <div className="modal-overlay">
                //     <div className="modal-container flex items-center justify-center flex-col">
                //         <div className="bg-black flex items-center gap-12 justify-center p-3 w-full">
                //             <h1 className="Header__text font-[700] text-white" style={{ fontSize: '24px' }}>
                //                 Payment For Test
                //             </h1>
                //             <i className="ri-close-fill text-white border rounded-full pl-1 pr-1 cursor-pointer hover:text-red" onClick={handleModalClose}></i>
                //         </div>
                //         <div className="flex items-center justify-center flex-col">
                //             <p className="Paragraph__etxt font-[600] pt-4 pb-2" style={{ fontSize: '16px' }}>
                //                 If you want to give this <br /> test, you'll have to pay for this.
                //             </p>
                //             <img src="/assates/Razoperay.png" alt="Payment" />
                //         </div>
                //         <div className="modal-buttons">
                //                 <button className="btn-next" onClick={() => handleRazorpayPayment(selectedTest)}>
                //                 Continue for payment
                //             </button>
                //         </div>
                //     </div>
                // </div>

                <div className="modal-overlay">
                    <div className="modal-container flex items-center justify-center flex-col">
                        <div className="bg-black flex items-center gap-12 justify-center p-3 w-full">
                            <h1 className="Header__text font-[700] text-white" style={{ fontSize: '24px' }}>
                                Payment For Test
                            </h1>
                            <i
                                className="ri-close-fill text-white border rounded-full pl-1 pr-1 cursor-pointer hover:text-red"
                                onClick={handleModalClose}
                            ></i>
                        </div>

                        <div className="flex items-center justify-center flex-col">
                            <p className="Paragraph__etxt font-[600] pt-4 pb-2" style={{ fontSize: '16px' }}>
                                If you want to give this <br /> test, you'll have to pay for this.
                            </p>
                            <img src="/assates/Razoperay.png" alt="Payment" />
                        </div>

                        <div className="mt-4">
                            <input
                                type="text"
                                placeholder="Enter Coupon Code"
                                className="border px-3 py-2 rounded w-64"
                                value={couponCode}
                                onChange={(e) => setCouponCode(e.target.value)}
                            />
                            <button
                                onClick={applyCoupon}
                                className="ml-2 px-3 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                            >
                                Apply
                            </button>
                            {couponError && <p className="text-red-500 mt-2">{couponError}</p>}
                            {successMessage && <p className="text-green-500 mt-2">{successMessage}</p>}
                        </div>

                        <div className="modal-buttons mt-4">
                            <button className="btn-next" onClick={() => handleRazorpayPayment(selectedTest)}>
                                Continue for payment
                            </button>
                        </div>
                    </div>
                </div>

            )}


            {showResultModal && testResult && (
                <div className="modal-overlay">
                    <div className="Exam__result__model bg-white rounded-xl">
                        <div className='header bg-black rounded-tl-lg rounded-tr-lg text-white p-3 relative '>
                            <h2 className='text-center font-bold Header__text'>Result</h2>
                            <i className="ri-close-circle-line absolute top-4 text-[17px] right-3" onClick={handleResultModalClose}></i>
                        </div>

                        <div className="modal-content p-2 Paragraph__etxt">
                            <div className='border-b p-2 flex justify-between'>
                                <label>Test Name</label>
                                <label><b>{testResult.testInfo.name}</b></label>
                            </div>

                            <div className='border-b p-2 flex justify-between'>
                                <label>Date of Given</label>
                                <label><b>{testResult.Created_date}</b></label>
                            </div>


                            <div className='border-b p-2 flex justify-between'>
                                <label>Total Marks</label>
                                <label><b>{testResult.fullMark}</b></label>
                            </div>


                            <div className='border-b p-2 flex justify-between'>

                                <label>Marks Obtained</label>
                                <label><b>{testResult.resultMark}</b></label>
                            </div>

                            <div className='border-b p-2 flex justify-between'>
                                <label>Right Attempts</label>
                                <label><b>{testResult.correctCount}</b></label>
                            </div>

                            <div className='border-b p-2 flex justify-between'>
                                <label>Wrong Attempts</label>
                                <label><b>{testResult.wrongCount}</b></label>
                            </div>

                            <div className='border-b p-2 flex justify-between'>
                                <label>Not Attempts</label>
                                <label><b>{testResult.notAttempted}</b></label>
                            </div>

                            <div className='border-b p-2 flex justify-between'>
                                <label>Need Counselling</label>
                                <label><b>{updatedTestResult.needCounselling ? 'Yes' : 'No'}</b></label>
                            </div>
                            <div className="mt-4">
                                <Bar
                                    data={data}
                                    options={{
                                        responsive: true,
                                        scales: {
                                            y: {
                                                beginAtZero: true,
                                            },
                                        },
                                    }}
                                />
                            </div>
                            <div className="flex justify-between mt-4 gap-8">
                                <button
                                    className="flex items-center justify-center gap-2 px-4 py-2 border border-black rounded-full text-black"
                                    onClick={() => window.open(testResult.filePath, "_blank")}
                                >
                                    <i className="ri-download-line"></i> Download PDF
                                </button>


                                {updatedTestResult.needCounselling && (
                                    <button
                                        className="px-6 py-2 bg-black text-white rounded-full"
                                        onClick={() => navigate("/dashboard/counselling")}
                                    >
                                        Schedule Call with Consultant
                                    </button>
                                )}
                            </div>


                            <div>

                            </div>

                        </div>
                    </div>

                </div>
            )}

        </section>
    );
};

export default Exams__test;
